export default "__VITE_ASSET__0HW_ePQU__"